import React, { PureComponent } from 'react';
import {Helmet} from "react-helmet";
import PropTypes from 'prop-types';
import { Col, Container } from 'reactstrap';
import PdmiCredentialsHOC from './PdmiCredentialsHOC';
import PdmiForm from '../../components/forms/PdmiForm';
import msgs from '../../config/messages';
import './PdmiCredentials.scss';

class PdmiCredentials extends PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
  };

  render() {
    const { onSubmit } = this.props;
    return (
      <div className="nf-pdmi-credentials">
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - PDMI Credentials Page</title>     
        </Helmet>
        <Container>
          <Col sm={12}>
            <h1 className="nf-pdmi-credentials__header">
              {msgs.PdmiCredentials.header}
            </h1>
          </Col>
          <PdmiForm onSubmit={onSubmit} />
        </Container>
      </div>
    );
  }
}

export default PdmiCredentialsHOC(PdmiCredentials);



// WEBPACK FOOTER //
// ./src/pages/PdmiCredentials/PdmiCredentials.jsx